export class ProductCodeDescription {
    Code: string = "";
    Description: string = "";
}

export const ProductTypes: ProductCodeDescription[] = [
  { Code: "M.1", Description: "GEA Bare Piston" },
  { Code: "B.2.3", Description: "GEA Pistons (VLX)" },
  { Code: "B.2.4", Description: "GEA Pistons (VMX)" },
  { Code: "B.2.10", Description: "Custom Pistons" },
  { Code: "D.4.3", Description: "Custom Piston Chillers" },
  { Code: "D.4.4", Description: "BluGenium" },
  { Code: "M.2", Description: "GEA Bare Screws" },
  { Code: "B.2", Description: "GEA Screws (GL)" },
  { Code: "B.2.1", Description: "GEA Screws (GLX)" },
  { Code: "B.2.2", Description: "GEA Screws (GMX)" },
  { Code: "I.1", Description: "Standard Gas Compressors (UOPR)" },
  { Code: "B.2.11", Description: "Custom Screws" },
  { Code: "I.1.1", Description: "Custom Gas Compressors" },
  { Code: "J.1.2", Description: "Custom Screw Chillers" },
  { Code: "B.2.5", Description: "GEA BluAstrum" },
  { Code: "B.2.6", Description: "Standard Heat Pumps (RedGenium)" },
  { Code: "B.2.8", Description: "Custom Piston Heat Pumps" },
  { Code: "B.2.7", Description: "Standard Heat Pumps (RedAstrum) " },
  { Code: "B.2.9", Description: "Custom Screw Heat Pumps" },
  { Code: "B.2.12", Description: "Blu-Red Fusion" },
  { Code: "K.1", Description: "Controls" },
  { Code: "K.1.1", Description: "System Panels and Upgrades" },
  { Code: "K.1.2", Description: "Retrofit Panels and Upgrades" },
  { Code: "K.1.3", Description: "Controls / Other" },
  { Code: "E.1", Description: "Spare Parts" },
  { Code: "B.3", Description: "Non-GEA Screws" },
  { Code: "F.7.1", Description: "Motors" },
  { Code: "F.7.2", Description: "Starters" },
  { Code: "F.7.3", Description: "Plate HX" },
  { Code: "F.7", Description: "Other Products" },
  { Code: "L.1.2", Description: "Shell and Tube HX" },
];

export function GetProductCodeDescription(code: string) {
    let codeDescription = ProductTypes.find(x => x.Code === code);
    if (codeDescription) {
        return codeDescription.Description;
    }
    else {
        return "N/A";
    }
}

export class ProductCodeGroup {
  Group: string = "";
  Codes: string[] = [];
}

export const ProductCodeGroups: ProductCodeGroup[] = [
  {
    Group: "All",
    Codes: ["B.2.1", "B.2.2", "B.2", "B.2.4", "B.2.11", "I.1", "I.1.1", "B.2.5", "D.4.4", "B.2.6", "B.2.7", "J.1.2", "K.1.3", "K.1.2", "K.1.1", 'A.1', 'B.3', 'F.7', 'F.7.1', 'F.7.2', 'L.1.2', 'M.1', 'M.2']
  },
  {
    Group: "Std Packages",
    Codes: ["B.2.1", "B.2.2", "B.2", "B.2.4"]
  },
  {
    Group: "Custom Packages",
    Codes: ["B.2.11"]
  },
  {
    Group: "Gas Compressors",
    Codes: ["I.1", "I.1.1"]
  },
  {
    Group: "Std Chillers & Heat Pumps",
    Codes: ["B.2.5", "D.4.4", "B.2.6", "B.2.7"]
  },
  {
    Group: "Custom Chillers",
    Codes: ["J.1.2"]
  },
  {
    Group: "Controls",
    Codes: ["K.1.3", "K.1.2", "K.1.1"]
  },
  {
    Group: "Other",
    Codes: ['A.1', 'B.3', 'F.7', 'F.7.1', 'F.7.2', 'L.1.2', 'M.1', 'M.2']
  }
];